/* 
 * @author Tommy Brière
 * @copyright (c) 2016 Groupe PVP
 * @fileoverview 
 *  Système de comportement, ajouté un comportement à un selecteur jquery
 *  & executé ce comportement quand du contenu est ajouté
 */
(function($g, $) {
    "use strict";
    
    function Behavior() {
        //var me = this;
        var ts = [];
        this.tasks = ts;
        
        function run($dom, t) {
            var sel = t[0];
            var f = t[1];
            if (f) {
                var title = $dom ? "dom find" : "jQuery";
                title += " " + sel;
                /*if ($g.time) {
                    $g.time(title);
                }*/
                var $find = $dom ? $dom.find(sel).addBack(sel) : $(sel);
                /*$dom.filter(sel).each(f);
                var $find = $dom.find(sel);*/
                /*if ($g.time) {
                    $g.timeEnd(title);
                }*/
                $find.each(f);
            }
        }
        
        function unrun($dom, t) {
            var sel = t[0];
            var f = t[2];
            if (f) {
                $dom.filter(sel).each(f);            
                $dom.find(sel).each(f);            
            }
        }
        
        /**
         * Ajoute un comportement
         * La fonctione est appelé par each jquery
         * @param {string} sel      Sélecteur jquery
         * @param {function} f      Function à appelé pour chaque élément
         * @param {function} uf     Function à appelé sur detach
         * @returns {undefined}
         */
        this.add = function(sel, f, uf) {
            var t = [sel,f,uf];
            ts.push(t);
            run(null, t);
        };
        
        this.remove = function(sel, f) {
            for (var i=0; i < ts.length; i++) {
                var t = ts[i];
                var tsel = t[0];
                var tf = t[1];                
                if (tsel===sel && tf===f) {
                    ts.splice(i,1);
                    i--;
                }
            }
        };
        
        /**
         * Attache les comportement sur un objet jquery
         * @param {jQuery} $dom     objet jquery
         * @returns {undefined}
         */
        this.attach = function($dom) {
            for (var i in ts) {
                var t = ts[i];
                run($dom, t);
            }
        };
        
        /**
         * Nettoyer les comportements
         * @param {jQuery} $dom
         * @returns {undefined}
         */
        this.detach = function($dom) {
            for(var i in ts) {
                var t = ts[i];
                unrun($dom, t);
            }            
        };
    }
    
    $g.Behavior = Behavior;
    $g.behavior = new Behavior();
    
})(PVPGEngine, jQuery);